import { Client } from "./_clientService";

export async function getCardBGs(payload: any) {
  const resp = await new Client({
    path: `/card-bg/list`,
    payload,
  }).post();

  return resp;
}

export async function createCardBG(payload: any) {
  const resp = await new Client({
    path: `/card-bg/create`,
    payload,
  }).post();

  return resp;
}

export async function updateCardBG(payload: any) {
  const resp = await new Client({
    path: `/card-bg/update/`,
    payload,
  }).post();

  return resp;
}

export async function deleteCardBG(cardBgId: any) {
  const resp = await new Client({
    path: `/card-bg/delete`,
    payload: { cardBgId },
  }).post();

  return resp;
}

export async function getCardBGInfo(cardBgId: any) {
  const resp = await new Client({
    path: `/card-bg/info/`,
    payload: { cardBgId },
  }).post();

  return resp;
}
